import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { GridTargetsBase } from '../grid-target-base';
import { getIncludedLocationBasicConfig, getExcludedLocationBasicConfig } from './basic-config';
import { areEqual } from '../components/utility';

export const IncludedLocationGrid = React.memo((props) => {
  const i18n = useContext(I18nContext);
  const { data, setData } = props;

  const params = {
    ...getIncludedLocationBasicConfig(i18n),
  };

  return (
    <div className="included-location-target-wrapper">
      <GridTargetsBase data={data} setData={setData} {...params} />
    </div>
  );
}, areEqual);

IncludedLocationGrid.propTypes = {
  data: PropTypes.shape({}).isRequired,
  setData: PropTypes.func.isRequired,
};


export const ExcludedLocationGrid = React.memo((props) => {
  const i18n = useContext(I18nContext);
  const { data } = props;

  const params = {
    ...getExcludedLocationBasicConfig(i18n),
  };

  return (
    <div className="excluded-location-target-wrapper">
      <GridTargetsBase data={data} {...params} />
    </div>
  );
}, areEqual);

ExcludedLocationGrid.propTypes = {
  data: PropTypes.shape({}).isRequired,
  setData: PropTypes.func.isRequired,
};

